import { useRef } from 'react';
import cx from 'classnames';
import { useReactDndConstructs } from '../../../../dnd/ReactDndContext';
import { getDndDesignTokens } from '../../../../style/reactDnd/DndStyleTokens';
import { useDesignTokens } from '../../../../theme';
import dnd from './DroppableZeroState.css.json';
import './DroppableZeroState.css';
import { jsx as _jsx } from "react/jsx-runtime";
export const DroppableZeroState = props => {
  const dropRef = useRef(null);
  const {
    useDrop
  } = useReactDndConstructs();
  const [{
    hoverClassName
  }, drop] = useDrop({
    accept: props.allowDropTypes,
    collect: monitor => {
      let hoverClassName = '';
      if (monitor.isOver({
        shallow: true
      }) && monitor.canDrop()) {
        hoverClassName = dnd.dropLine;
      }
      return {
        hoverClassName
      };
    },
    drop: (droppedItem, monitor) => {
      if (!monitor.didDrop()) {
        const dropTarget = {
          index: 0,
          dragType: props.dragType,
          dndPrefix: props.dndPrefix
        };
        props.onDrop?.({
          monitor,
          dropTarget,
          droppedItem
        });
      }
    }
  });
  const dt = useDesignTokens();
  const dndTokens = getDndDesignTokens(dt);
  drop(dropRef);
  return /*#__PURE__*/_jsx("div", {
    ref: dropRef,
    "data-testid": props.testId,
    style: {
      ...dndTokens
    },
    className: cx(dnd.droppableZeroState, hoverClassName)
  });
};
//# sourceMappingURL=DroppableZeroState.js.map